import { styled } from "@mui/material/styles";
import { isEmpty } from "ramda";

export const Wrapper = styled("div", {
  shouldForwardProp: (prop) => prop !== "vertical",
})(({ vertical }) => ({
  ...(vertical && {
    display: "flex",
    justifyContent: "center",
  }),
}));

export const Root = styled("div", {
  shouldForwardProp: (prop) => prop !== "vertical" && prop !== "bordered" && prop !== "inviteTheme",
})(({ theme, vertical, bordered, inviteTheme }) => {
  const borderColor = !isEmpty(inviteTheme) ? inviteTheme.invitationBorderColor : "#fff";
  const getBorder = (width) => `${width}px solid ${borderColor}`;

  return {
    width: "100%",
    height: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: 778,
    ...(vertical && {
      width: 288,
    }),
    ...(bordered && {
      boxShadow: "0 4px 9px 0 rgba(0,0,0,.25)",
      ...(!vertical
        ? {
            border: getBorder(7),
            [theme.breakpoints.up("mobile")]: {
              border: getBorder(16),
            },
            [theme.breakpoints.up("tablet")]: {
              border: getBorder(20),
            },
          }
        : {
            border: getBorder(7),
          }),
    }),
  };
});

export const Player = styled("div")({
  width: "100%",
  height: "100%",
  boxSizing: "border-box",
  position: "relative",
  overflow: "hidden",
});
